import { createContext } from "react";

const AppointmentsContext = createContext();

export default AppointmentsContext;
